import { FC } from 'react';

import { IconView } from '@gem/ui-kit';

import { DevicePlatform, DeviceStatus } from '../Device.types';
import { useDeviceIconPresenter } from './DeviceIcon.presenter';
import styles from './DeviceIcon.styles.m.css';

interface IDeviceIconProps {
  className?: string;
  platform: DevicePlatform;
  status?: DeviceStatus;
}

export const DeviceIcon: FC<IDeviceIconProps> = (props) => {
  const { className, platform, status } = props;
  const presenter = useDeviceIconPresenter({ platform, status });

  return (
    <div className={styles.container}>
      <IconView
        Icon={presenter.platformIcon}
        className={className}
      />
      {presenter.statusIcon && (
        <IconView
          Icon={presenter.statusIcon}
          className={styles.statusIcon}
        />
      )}
    </div>
  );
};
